import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";

import QuickLinks from "../../../components/Common/QuickLinks";
import { fetchData } from "../../../utils/fetchData";
import { BlocksRenderer } from "../../../components/BlockRenderer";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
const currentDomain = process.env.REACT_APP_SUB_DOMAIN;
const CommonResearchPublications = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.research_publications, setData);
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>Research Publications – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Research & Publications"
          pageName="Research & Publications"
          breadcrumbsClass="Research & Publications"
        />
        {getMenu()}

        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3
                      style={{ marginBottom: "20px" }}
                      title={data?.data?.attributes?.Page_Heading}
                    >
                      {data?.data?.attributes?.Page_Heading}
                    </h3>
                    {
                      <BlocksRenderer
                        content={data?.data?.attributes?.Body || []}
                      />
                    }
                  </div>
                </div>
              </div>
              {showQuickLinks(currentDomain) && (
                <div className="col-lg-3 pl-20 md-pl-14">
                  <div className="about-intro">
                    <QuickLinks />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default CommonResearchPublications;
const showQuickLinks = (currentDomain) => {
  if (currentDomain === "ssit") return true;
  else return false;
};
